<div class="confirm-dialog">
  <h2 mat-dialog-title>Delete Threshold Confirmation</h2>
  <div class="inner">
    <button [mat-dialog-close]="false" aria-label="Close" class="dialog__close-btn close-button">
      <i class="fa fa-times">close</i>
    </button>
    <div mat-dialog-content style="white-space: pre-line; line-height: 30px">
      <b> Are you sure you want to delete the threshold ?</b> <br>
      <b>Cron Description - </b> {{data.cronDescriptor}} <br>
      <b>Component Key Value - </b> {{data.componentKeyValue}} <br>
      <b>Transit Time - </b>  {{data.transitTime != "*" ? data.transitTime: "ALL"}} <br>
      <b>Threshold - </b> {{data.threshold}} <br>
    </div>
    <div mat-dialog-actions [align]="'end'">
      <button class="confirm-dialog-button-cancel" mat-raised-button [mat-dialog-close]="false">Cancel</button>
      <button class="confirm-dialog-button-confirm" mat-raised-button color="primary" [mat-dialog-close]="true">Delete</button>
    </div>
  </div>
</div>
<div class="overlay" ></div>
